import { IPatchImageUploadBody } from '@types';
import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

async function patchAdminImageData(body: IPatchImageUploadBody): Promise<AxiosResponse<FetchResult<string>>> {
  const response = await instance.patch(`/admin/images`, { ...body });
  return response;
}

const usePatchAdminImageData = (
  onSuccess?: (data: AxiosResponse<FetchResult<string>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { data, mutateAsync } = useMutation({
    mutationKey: ['patch', `/admin/images`],
    mutationFn: (body: IPatchImageUploadBody) => patchAdminImageData(body),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { data, mutateAsync };
};

export default usePatchAdminImageData;
